import {gql} from '@apollo/client'

export const GET_PAYMENT_RULE = gql`
  query GetPaymentRule($paymentRuleId: ID!) {
    paymentRule(id: $paymentRuleId) {
      id
      description
      account {
        id
        displayName @client
        name
        contactFirstName
        contactLastName
      }
      conditions {
        id
        fieldName
        matchType
        text
      }
    }
  }
`

export const CREATE_PAYMENT_RULE = gql`
  mutation CreatePaymentRule($conditions: JSON, $description: String, $accountId: ID) {
    paymentRule(conditions: $conditions, description: $description, accountId: $accountId) {
      id
      description
      account {
        displayName @client
        name
        contactFirstName
        contactLastName
      }
      conditions {
        id
        fieldName
        matchType
        text
      }
    }
  }
`

export const UPDATE_PAYMENT_RULE = gql`
  mutation UpdatePaymentRule($id: ID!, $conditions: JSON, $description: String, $accountId: ID) {
    paymentRule(id: $id, conditions: $conditions, description: $description, accountId: $accountId) {
      id
      description
      account {
        displayName @client
        name
        contactFirstName
        contactLastName
      }
      conditions {
        id
        fieldName
        matchType
        text
      }
    }
  }
`
